import { contactOptions, contactOptionText, isNonCommercial } from '../../utils/clientContacts.js';

// The optional non-commercial contact on a SOW, shared by New Opportunity and
// Edit. Offers only contacts marked non-commercial (plus whoever is already
// chosen), and says how to add one when the client has none yet.
export default function NonCommercialContactSelect({ contacts, clientId, value, commercialId, onChange }) {
  const options = contactOptions(contacts, { nonCommercial: true, selectedId: value, excludeId: commercialId });
  const noneMarked = !!clientId && !(contacts || []).some(isNonCommercial);
  return (
    <>
      <select className="form-select" value={value || ''} onChange={e => onChange(e.target.value)} disabled={!clientId}>
        <option value="">{clientId ? '— none —' : 'Select client first'}</option>
        {options.map(c => <option key={c.id} value={c.id}>{contactOptionText(c, { nonCommercial: true })}</option>)}
      </select>
      {noneMarked && (
        <p className="mt-0.5 text-[8px] text-gray-400">
          Nobody at this client is marked non-commercial yet. Add one with + New, or tick Non-commercial on the contact under Clients.
        </p>
      )}
    </>
  );
}
